import React, { useState, useEffect } from "react";
import UserContext from "../../UserContext";
import { getMessages, readMessages } from "../../utils/functions";
import {
  formatPastTimeToOneIndicator,
  getSummary,
} from "../../utils/global-functions";
import { url } from "../../utils/url";
import UserProfile from "../../images/avatar-defaul-girls.jpg";

export default function ChatItem({ chat, changeSelected, load, selected }) {
  const [chatMessages, setchatMessages] = React.useState([]);
  const { user, mode } = React.useContext(UserContext);
  const [lastmessage, setlastmessage] = React.useState();
  const [dark, setDark] = useState(false);

  React.useEffect(() => {
    async function loadLatestMessages() {
      // let messages = await getMessages(chat._id, user.token);
      let messages = chat.messages || (await getMessages(chat._id, user.token));
      setlastmessage(messages[messages.length - 1]);
      setchatMessages(messages || []);
    }
    loadLatestMessages();
  }, [chat, user, load]);

  async function readmessages(userId) {
    await readMessages(userId, user.token);
  }

  useEffect(() => {
    let darkmode = localStorage.getItem("darkmode")
      ? JSON.parse(localStorage.getItem("darkmode"))
      : false;
    setDark(darkmode);
  }, [mode]);

  
  let img_url = chat?.image
  ? chat?.image
  : url + chat?.profile?.url || UserProfile;

  return (
    <div
      className={
        dark
          ? `chat-item flex items-center my-4 py-2 px-2 hover:bg-gray-900 cursor-pointer ml-2 ${
              selected._id === chat._id && "bg-gray-900"
            }`
          : `chat-item flex items-center my-4 py-2 px-2 hover:bg-gray-100 cursor-pointer ml-2 ${
              selected._id === chat._id && "bg-gray-100"
            }`
      }
      onClick={() => {
        changeSelected(chat, chatMessages);
        readmessages(chat._id);
      }}
    >
      <img
        src={img_url}
        alt={chat.username}
        style={{ height: "50px", width: "50px", borderRadius: "50%" }}
        className="mr-4 object-cover"
      ></img>
      <div className="mt-0" style={{ flex: 1 }}>
        <div className="d-flex items-center mb-0 mt-0">
          <p className="font-weight-bolder text-md mr-1">{chat.username}</p>
          {chat.account_type === "VERIFIED" && (
            <p title="Account verified">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="20"
                height="20"
              >
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.997-6l7.07-7.071-1.414-1.414-5.656 5.657-2.829-2.829-1.414 1.414L11.003 16z"
                  fill="rgba(249,2,2,1)"
                />
              </svg>
            </p>
          )}
        </div>
        <div className="h-1"></div>
        <div style={{ marginBottom: "0.1rem" }} className="text-gray-500">
          {getSummary(lastmessage?.message, 25) || "..."}
        </div>
      </div>

      <p className="text-gray-500 font-weight-bold">
        {formatPastTimeToOneIndicator(lastmessage?.createdAt)}
      </p>
    </div>
  );
}
